const state = {
  commonInfo: {
    // 発行対象
    issueObj: null,
    // 検索対象
    searchTarget: null,
    // 画面モード
    modeScreenHistory: null,
    modeScreenReissue: null,
    modeScreenConfirmationPrint: null,
    breadcrumbId: null
  }
};

const getters = {
  commonInfo: state => state.commonInfo
};

const mutations = {
  changeCommonInfo(state, commonInfo) {
    if (!commonInfo) {
      return;
    }
    if (commonInfo.issueObj) {
      state.commonInfo.issueObj = commonInfo.issueObj;
    }
    if (commonInfo.searchTarget) {
      state.commonInfo.searchTarget = commonInfo.searchTarget;
    }
    if (commonInfo.modeScreenHistory) {
      state.commonInfo.modeScreenHistory = commonInfo.modeScreenHistory;
    }
    if (commonInfo.modeScreenReissue) {
      state.commonInfo.modeScreenReissue = commonInfo.modeScreenReissue;
    }
    if (commonInfo.modeScreenConfirmationPrint) {
      state.commonInfo.modeScreenConfirmationPrint =
        commonInfo.modeScreenConfirmationPrint;
    }
    if (commonInfo.breadcrumbId || commonInfo.breadcrumbId === 0) {
      state.commonInfo.breadcrumbId = commonInfo.breadcrumbId;
    }
  },
  clearCommonInfo(state) {
    state.commonInfo = {
      // 発行対象
      issueObj: null,
      // 検索対象
      searchTarget: null,
      // 画面モード
      modeScreenHistory: null,
      modeScreenReissue: null,
      modeScreenConfirmationPrint: null,
      breadcrumbId: null
    };
  }
};

export default {
  state,
  getters,
  mutations
};
